import { Tooltip } from "bootstrap";
import { LoadingButton } from "../loadingButton";
import { resetTurnstile } from "../turnstile";
// API Key generation functionality
export function setupApiKeyGeneration() {
    document.whenHtmlElementExists("apiKeyGenerationForm", "generateApiKeyBtn", "apiKeyDisplay", "successMessage", "errorMessage", (form, generateApiKeyBtn, apiKeyDisplay, successMessage, errorMessage) => {
        generateApiKeyBtn.addEventListener("click", async (event) => {
            const copyApiKeyBtn = document.getHtmlElementById("copyApiKeyBtn");
            // Initialize tooltips for copy button
            if (copyApiKeyBtn) {
                new Tooltip(copyApiKeyBtn);
            }
            const signInLoadingButton = LoadingButton.getOrCreateInstance(generateApiKeyBtn);
            signInLoadingButton.start();
            event.preventDefault();
            try {
                // Reset messages
                errorMessage.bootstrapHide();
                successMessage.bootstrapHide();
                const formData = new FormData(form);
                const data = new URLSearchParams();
                formData.forEach((value, key) => {
                    data.append(key, value.toString());
                });
                const originalContent = generateApiKeyBtn.innerHTML;
                generateApiKeyBtn.innerHTML = '<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Generating...';
                generateApiKeyBtn.disabled = true;
                const result = await fetch("/dashboard/apikey/regenerate", {
                    body: data,
                    method: "POST",
                });
                if (result.status === 200) {
                    successMessage.bootstrapShow();
                    form.bootstrapHide();
                    const json = await result.json();
                    const apiKey = json.apiKey;
                    apiKeyDisplay.value = apiKey;
                }
                else {
                    const errorMessageText = document.getHtmlElementById("errorMessageText");
                    if (errorMessageText) {
                        let errorText = "An unexpected error occurred.";
                        try {
                            const errorJson = await result.json();
                            errorText = errorJson?.error || errorText;
                        }
                        catch (error) {
                            console.error("Failed to parse error JSON:", error);
                        }
                        errorMessage.bootstrapShow();
                        errorMessageText.innerHTML = errorText;
                        generateApiKeyBtn.innerHTML = originalContent;
                        generateApiKeyBtn.disabled = false;
                    }
                }
            }
            finally {
                // Stop loading button
                signInLoadingButton.stop();
                resetTurnstile();
            }
            // Copy to clipboard functionality
            if (copyApiKeyBtn) {
                copyApiKeyBtn.addEventListener("click", () => {
                    // Get the API key value
                    const apiKey = apiKeyDisplay.value;
                    // Copy to clipboard
                    navigator.clipboard
                        .writeText(apiKey)
                        .then(() => {
                        // Update tooltip content temporarily
                        const tooltip = Tooltip.getOrCreateInstance(copyApiKeyBtn);
                        const originalTitle = copyApiKeyBtn.getAttribute("data-bs-original-title");
                        // Change tooltip text to show copied
                        copyApiKeyBtn.dataset.bsOriginalTitle = "Copied!";
                        tooltip.show();
                        // Update button icon temporarily
                        copyApiKeyBtn.innerHTML = '<i class="bi bi-check-lg"></i>';
                        // Reset tooltip and icon after 2 seconds
                        setTimeout(() => {
                            if (originalTitle) {
                                copyApiKeyBtn.dataset.bsOriginalTitle = originalTitle;
                            }
                            copyApiKeyBtn.innerHTML = '<i class="bi bi-clipboard"></i>';
                            tooltip.hide();
                        }, 2000);
                    })
                        .catch((err) => {
                        console.error("Could not copy text: ", err);
                    });
                });
            }
        });
    });
}
